import { JSX, useState } from 'react';
import { Button } from 'react-admin';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { CsvImportConfig } from './csv-import-types';
import { CsvImportDialog } from './CsvImportDialog';

/** The Import CSV button for a list page's toolbar. */
export const CsvImportButton = ({ config }: { config: CsvImportConfig }): JSX.Element => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <>
            <Button label="Import CSV" onClick={ () => setOpen(true) }>
                <UploadFileIcon />
            </Button>
            { open && <CsvImportDialog config={ config } open={ open } onClose={ () => setOpen(false) } /> }
        </>
    );
};
